import { createApp } from 'vue';
import { createAgonI18n } from '../../i18n';
import StyleWithPrints from './StyleWithPrints.vue';

declare const rootProps: never;

const i18n = createAgonI18n(rootProps['culture']);

createApp(StyleWithPrints, rootProps).use(i18n).mount('#app');
